import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { REQUEST_CLIENTS_TOTAL, CLIENT_ENCODED_DATA_REQUEST } from './types';

import {
  clientsTotalSuccess,
  clientsTotalFailure,
  clientEncodedDataSuccess,
  clientEncodedDataFailure,
} from './reducer';

const logger = new Logger('Saga:Monitor:ClientsTotal');

export function* getClientsTotal(action) {
  const { entityId } = action;
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield authApiService.get(
      routerService.generate('api.monitor.clients_total', { entityId }),
    );
    logger.info('Got clients total data');
    yield put(clientsTotalSuccess(response.data));
  } catch (error) {
    logger.error(error);
    yield put(clientsTotalFailure(error));
  }
}

export function* requestClientsListExportData(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.monitor.export_clients', { entityId: action.entityId }),
      action.payload,
    );
    action.promise && action.promise.resolve(response.data);
    yield put(clientEncodedDataSuccess(response.data.value));
  } catch (error) {
    logger.error('Failed to get selected clients CSV file', error);
    action.promise && action.promise.reject(error);
    yield put(clientEncodedDataFailure(error));
  }
}

export default function* clientsTotalSaga() {
  return yield all([
    takeLatest(REQUEST_CLIENTS_TOTAL, getClientsTotal),
    takeLatest(CLIENT_ENCODED_DATA_REQUEST, requestClientsListExportData),
  ]);
}
